import { render, staticRenderFns } from "./AmazonVendorData.vue?vue&type=template&id=5d6cd08f"
import script from "./AmazonVendorData.vue?vue&type=script&lang=js"
export * from "./AmazonVendorData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports